import { CommonEntrypoint } from "entrypoint/CommonEntrypoint";
import 'presentation/style/index.scss';
import EmailTemplateMaintenanceCont from "presentation/view/container/EmailTemplate/EmailTemplateContMain";

CommonEntrypoint(<EmailTemplateMaintenanceCont/>)